import React from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { connect } from 'react-redux';
import {
	updateAgendaItem,
	updateAttendeeAgendaItem,
	duplicateAttendeeAgendaItem,
	createAgendaItem,
	deleteAgendaItem,
	deleteAttendeeAgendaItem,
	clearAgendaFilterAndScroll,
} from '@/redux/actions';

const WS_AGENDA_BY_HTTP = {
	CREATE: 'agenda/POST',
	UPDATE: 'agenda/:agendaItemID/PATCH',
	DELETE: 'agenda/:agendaItemID/DELETE',
};

const AgendaSubscriptions = props => {
	const {
		socket,
		currentEventId,
		children,
		updateAgendaItem,
		updateAttendeeAgenda,
		duplicateAttendeeAgendaItem,
		deleteAttendeeAgendaItem,
		createAgendaItem,
		deleteAgendaItem,
		clearAgendaFilterAndScroll,
	} = props;
	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribeToAgenda = () => {
		socket.emit('event/:eventID/agenda/SUBSCRIBE', { eventID: currentEventId });
		console.log('⚡️ AgendaSubscriptions Mounted ⚡️');
	};

	const unsubscribeToAgenda = () => {
		clearAgendaFilterAndScroll('AgendaSubscriptions.unsubscribeToAgenda');
		socket.emit('event/:eventID/agenda/UNSUBSCRIBE', { eventID: currentEventId });
		console.log(`🚶‍♂️ AgendaSubscriptions Unmounted 🚶‍♂️`);
	};

	const listenForCreatedAgendaItem = () =>
		socket.on(WS_AGENDA_BY_HTTP.CREATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Agenda Item could not be created', error);
			else {
				const { route } = payload;
				if (route === 'attendee') duplicateAttendeeAgendaItem(data);
				else createAgendaItem(data);

				displayMessage('Agenda Item created');
			}
		});

	const listenForUpdatedAgendaItem = () =>
		socket.on(WS_AGENDA_BY_HTTP.UPDATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error updating agenda item', error);
			else {
				const { name, id } = data;
				updateAttendeeAgenda(data);
				updateAgendaItem(data);
				displayMessage(`${name} (ID: ${id}) session updated`);
			}
		});

	const listenForDeletedAgendaItem = () =>
		socket.on(WS_AGENDA_BY_HTTP.DELETE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error deleting agenda item', error);
			else {
				const { agendaItemName } = payload;

				deleteAttendeeAgendaItem(data);
				deleteAgendaItem(data);

				displayMessage(`${agendaItemName} session deleted`);
			}
		});

	const listeners = () => [
		listenForCreatedAgendaItem,
		listenForUpdatedAgendaItem,
		listenForDeletedAgendaItem,
	];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribeToAgenda}
				unsub={unsubscribeToAgenda}
				listeners={listeners()}
				routes={Object.values(WS_AGENDA_BY_HTTP)}
			/>
			{React.cloneElement(children, propsToSend)}
		</>
	);
};

const msp = ({ ws, auth, events }) => ({
	socket: ws.socket,
	auth0Token: auth.auth0Token,
	currentEventId: events.currentEvent.id,
});

const mdp = dispatch => ({
	updateAttendeeAgenda: agendaItem => dispatch(updateAttendeeAgendaItem(agendaItem)),
	updateAgendaItem: agendaItem => dispatch(updateAgendaItem(agendaItem)),
	duplicateAttendeeAgendaItem: agendaItem => dispatch(duplicateAttendeeAgendaItem(agendaItem)),
	createAgendaItem: agendaItem => dispatch(createAgendaItem(agendaItem)),
	deleteAgendaItem: agendaItem => dispatch(deleteAgendaItem(agendaItem)),
	deleteAttendeeAgendaItem: agendaItem => dispatch(deleteAttendeeAgendaItem(agendaItem)),
	clearAgendaFilterAndScroll: from => dispatch(clearAgendaFilterAndScroll(from)),
});

export default connect(msp, mdp)(AgendaSubscriptions);
